import defaultsDeep from 'lodash/defaultsDeep';
import defaultConfig from './default';

const APP_ENV = process.env.REACT_APP_ENV || 'development';
let config = defaultConfig;

try {
  const envConfig = require('./env/' + APP_ENV).default;
  config = defaultsDeep({}, envConfig, defaultConfig);

  config.environment = APP_ENV;
} catch (e) {
  throw new Error(`REACT_APP_ENV ${APP_ENV} is not supported.`);
}

export default Object.freeze(config);



// WEBPACK FOOTER //
// ./src/config/index.js